import { FieldStateV3, FormContext, FormStateV3 } from '../../../../commonv3/states/form/FormStateV3';
import { UserAddress } from '../../../types/userAddresses';
import { BooleanValidator, StringValidators } from '../../../../commonv3/states/form/validators';
import { action, makeObservable } from 'mobx';
import { ZipCodeApis } from '../../../apis/zipcodes';

export class UserAddressFormState extends FormStateV3<UserAddress> {
  constructor() {
    super({
      zipcode: new FieldStateV3<string>([
        StringValidators.required(),
        new BooleanValidator(async (value) => {
          if (!value) {
            return;
          }
          return await this.autofillIfNecessary();
        }, '無効な郵便番号です'),
      ]),
      prefecture: new FieldStateV3<string>([StringValidators.required()]),
      city: new FieldStateV3<string>([StringValidators.required()]),
      address: new FieldStateV3<string>([StringValidators.required()]),
      building: new FieldStateV3<string>([]),
    });

    makeObservable(this, {
      reloadUserAddress: action.bound,
      autofillIfNecessary: action.bound,
    });
  }

  init(initialValue: UserAddress = undefined) {
    this.reloadUserAddress(initialValue);
  }

  async reloadUserAddress(initialValue) {
    const newAddress: UserAddress = {
      zipcode: '',
      prefecture: '',
      city: '',
      address: '',
      building: '',
    };
    this._init('user_address', new FormContext(), { ...newAddress, ...(initialValue || {}) });
  }

  async autofillIfNecessary(): Promise<boolean> {
    try {
      const result = await ZipCodeApis.resolve(this.fields.zipcode.getDirtyValue());
      if (!result) {
        return false;
      }
      const { prefecture, city, address } = this.fields;
      if ((prefecture.getDirtyValue() || '').trim().length === 0) {
        prefecture.setDirtyValue(result.address1);
      }
      if ((city.getDirtyValue() || '').trim().length === 0) {
        city.setDirtyValue(result.address2);
      }
      if ((address.getDirtyValue() || '').trim().length === 0) {
        address.setDirtyValue(result.address3);
      }
      return true;
    } catch (e) {
      return false;
    }
  }
}
